import React, { useEffect, useRef } from "react";
import { MainNavigationProps } from "@/types/layout";
import { PrimaryNavItem } from "@/components/layout/Sidebar/PrimaryNavItem";
import autoAnimate from "@formkit/auto-animate";
import { useIsAppOnline } from "@/hooks/useIsAppOnline";

export const PrimaryNavigation: React.FC<MainNavigationProps> = ({ navigationItems, hideBurgerMenu }) => {
  const parent = useRef(null);
  const isAppOnline = useIsAppOnline();

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent]);

  return (
    <ul
      ref={parent}
      className={`border-gray-dark border-b py-4 font-condensed text-md dark:border-white-25 ${
        !navigationItems?.length ? "h-[291px]" : ""
      }`}
    >
      {navigationItems?.map((item, key) => (
        <PrimaryNavItem
          key={`primary-nav-item-${key}`}
          offline={isAppOnline}
          navigationItem={item}
          hideBurgerMenu={hideBurgerMenu}
        />
      ))}
    </ul>
  );
};
